"use client";

import { GuestGuard } from "@/components/auth-guard";

export default function AuthLayout({
	children,
}: Readonly<{
	children: React.ReactNode;
}>) {
	return (
		<GuestGuard>
			<div className="min-h-svh relative overflow-hidden">
				{/* Enhanced Animated Gradient Background */}
				<div className="absolute inset-0 bg-gradient-to-br from-background via-background to-muted/70"></div>
				<div className="absolute inset-0 bg-gradient-to-tl from-primary/20 via-transparent to-[hsl(var(--landing-page-accent-hsl))]/20 animate-pulse"></div>
				<div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/10 to-transparent animate-[shimmer_6s_ease-in-out_infinite]"></div>
				<div className="absolute inset-0 bg-gradient-to-bl from-[hsl(var(--landing-page-accent-hsl))]/10 via-transparent to-primary/15 animate-[wave_8s_ease-in-out_infinite]"></div>

				{/* Enhanced Animated Orbs */}
				<div className="absolute inset-0 overflow-hidden pointer-events-none">
					<div className="absolute -top-40 -left-40 w-[500px] h-[500px] bg-gradient-to-r from-primary/25 to-[hsl(var(--landing-page-accent-hsl))]/25 rounded-full blur-3xl animate-[float_8s_ease-in-out_infinite]"></div>
					<div className="absolute -bottom-40 -right-40 w-[400px] h-[400px] bg-gradient-to-l from-[hsl(var(--landing-page-accent-hsl))]/30 to-primary/20 rounded-full blur-2xl animate-[float_10s_ease-in-out_infinite_reverse]"></div>
					<div className="absolute top-1/3 left-1/4 w-80 h-80 bg-gradient-to-br from-primary/20 to-[hsl(var(--landing-page-accent-hsl))]/15 rounded-full blur-xl animate-[pulse_4s_ease-in-out_infinite]"></div>
					<div className="absolute top-1/2 right-1/3 w-72 h-72 bg-gradient-to-tl from-[hsl(var(--landing-page-accent-hsl))]/18 to-primary/12 rounded-full blur-xl animate-[float_12s_ease-in-out_infinite]"></div>
				</div>

				{/* Moving Gradient Waves */}
				<div className="absolute inset-0 overflow-hidden pointer-events-none">
					<div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-primary/8 to-transparent skew-y-12 animate-[wave_15s_linear_infinite]"></div>
					<div className="absolute bottom-0 right-0 w-full h-full bg-gradient-to-l from-transparent via-[hsl(var(--landing-page-accent-hsl))]/6 to-transparent -skew-y-6 animate-[wave_20s_linear_infinite_reverse]"></div>
				</div>

				{/* Auth Form - Centered */}
				<div className="relative flex flex-col justify-center items-center min-h-svh p-6 md:p-10 lg:p-16 z-10">
					{/* Floating geometric shapes */}
					<div className="absolute inset-0 overflow-hidden pointer-events-none">
						<div className="absolute top-20 left-20 w-32 h-32 bg-gradient-to-br from-[hsl(var(--landing-page-accent-hsl))]/10 to-primary/10 rounded-full blur-xl"></div>
						<div className="absolute bottom-40 right-10 w-24 h-24 bg-gradient-to-tl from-[hsl(var(--landing-page-accent-hsl))]/15 to-primary/5 rounded-full blur-lg"></div>
						<div className="absolute top-1/3 right-1/4 w-16 h-16 bg-gradient-to-r from-primary/10 to-[hsl(var(--landing-page-accent-hsl))]/10 rounded-full blur-md"></div>
					</div>

					{/* Grid pattern overlay */}
					<div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,.1)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.1)_1px,transparent_1px)] bg-[size:32px_32px] dark:bg-[linear-gradient(rgba(255,255,255,.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.02)_1px,transparent_1px)] opacity-50 pointer-events-none"></div>

					<div className="relative z-10">{children}</div>
				</div>
			</div>
		</GuestGuard>
	);
}
